import { required, url, minLength } from '@vuelidate/validators';

export const constructParameterRule = parameter => {
  const rules = {};
  if (parameter.required) {
    rules.required = required;
  }
  if (parameter.type === 'url') {
    rules.url = url;
  }
  return rules;
};

export default {
  name: {
    required,
    minLength: minLength(3),
  },
  displayName: {},
  description: {},
  template: {},
};
